import styled from "styled-components";


export const LinkContainer = styled.div`
    margin-top: 1rem;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const LinkBtn = styled.button`
    border: none;

    background-color: transparent;
    color: black;
`;


export const LinkAnchor = styled.a`
    font-size: 15px;
    color: #0575E6;

    &:hover {
        color: #0575E6;
        text-decoration: underline;
    }
`;
